import { render } from "./DatasetLogs.vue?vue&type=template&id=5b1f964c"
import script from "./DatasetLogs.vue?vue&type=script&lang=js"
export * from "./DatasetLogs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__